import React from "react";

interface CheckButtonProps {
  selected: boolean;
  noBorder?: boolean;
  label: string;
  onClick: () => void;
}

export const CheckButton = ({
  selected = false,
  noBorder = false,
  label = '',
  onClick
}: CheckButtonProps) => (
  <button
    onClick={onClick}
    className={`
     flex flex-row active:bg-gray-200 mr-2 px-2 py-1 rounded mb-2 self-start items-center
      ${noBorder ? '' : 'border border-ptTeal'}
    `}
  >
    <i className={`
      text-ptTeal mr-1
      ${noBorder ? 'text-xl' : 'text-lg'}
      fa ${selected ? 'fa-square-check' : 'fa-regular fa-square'}
    `}/>
    <div className={`${noBorder ? 'font-bold text-lg' : ''}`}>
      {label}
    </div>
  </button>
)